import React from 'react';
import { makeStyles } from '@material-ui/core';
import DonutChart from '../Charts/DonutChart';


export default function OEEContent(props) {
    const classes = useStyles();

    let totalOEEPercentage = String(Math.round((props.fakeDataWorkstation.quality + props.fakeDataWorkstation.performance + props.fakeDataWorkstation.availability) / 3))


    return (
        <React.Fragment>
            <div className={classes.header}>
                <div className={classes.OEE}>OEE</div>
                <div className={classes.percentage}>{totalOEEPercentage + "%"}</div>
            </div>
            <div className={classes.quality}>
                <DonutChart value={props.fakeDataWorkstation.quality} label={"Quality"} ></DonutChart>
            </div>
            <div className={classes.performance}>
                <DonutChart value={props.fakeDataWorkstation.performance} label={"Performance"}></DonutChart>
            </div>
            <div className={classes.availability}>
                <DonutChart value={props.fakeDataWorkstation.availability} label={"Availability"}></DonutChart>
            </div>

        </React.Fragment>
    )

}

const useStyles = makeStyles(() => ({
    chart: {
        width: "150px",
        height: "150px !important",
    },
    circle: {
        width: "80px",
        height: "80px",
        backgroundColor: "white",
        boxShadow: "0 0 15px 5px rgba(0,0,0,0.3)",
        borderRadius: "100px",
        marginLeft: "60px",
        zIndex: "99999",
        position: "relative"
    },
    donut: {
        height: "150px !important"
    },
    quality: {
        height: "192px"
    },
    performance: {
        height: "192px"
    },
    availability: {
        height: "192px"
    },
    OEE: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#8D8D8D',
        display: 'block',
        marginLeft: "20px",
        marginTop: "20px"
    },
    percentage: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#020100',
        display: 'block',
        marginLeft: "20px"
    }


}));